import type { NotificationDatabaseEntity } from "@/entities/notification-database";

import {
  isNotificationDatabaseRead,
  useMarkNotificationDatabaseAsRead,
} from "@/entities/notification-database";
import { useInvalidateNotificationsDatabase } from "@/entities/notifications-database";
import {
  useIsNotificationOptimisticRead,
  useNotificationOptimisticRead,
} from "@/modules/notification/notification-optimistic-read";
import { useNotificationsView } from "@/modules/notifications/notifications-view";

export const useNotificationCard = (
  notification: NotificationDatabaseEntity
) => {
  const { view, isFetching, invalidateSuffixes } = useNotificationsView();
  const { invalidateNotifications } = useInvalidateNotificationsDatabase();
  const { markAsRead } = useMarkNotificationDatabaseAsRead();
  const { activateOptimisticRead, removeOptimisticRead } =
    useNotificationOptimisticRead();

  // Use optimistic read state to instantly mark the card as read
  const isRead = isNotificationDatabaseRead(notification);
  const isOptimisticRead = useIsNotificationOptimisticRead(notification.id);
  const isUnread = isOptimisticRead ? false : !isRead;

  const isUnreadView = view === "unread_tab";
  const showPending = isUnreadView && isOptimisticRead && !isRead;

  const onSuccess = () => {
    invalidateNotifications(invalidateSuffixes);
  };

  const onError = () => {
    removeOptimisticRead(notification.id);
  };

  const onCardClick = () => {
    if (isRead) return;
    activateOptimisticRead(notification.id);
    markAsRead(notification.id, { onSuccess, onError });
  };

  return {
    isUnread,
    isPending: showPending ? isFetching : false,
    onCardClick,
  };
};
